(() => {
  const root = document.documentElement;
  const countdownText = (milliseconds) => {
    const seconds = Math.max(0, Math.floor(milliseconds / 1000));
    return `${String(Math.floor(seconds / 3600)).padStart(2, '0')}h ${String(Math.floor(seconds % 3600 / 60)).padStart(2, '0')}m ${String(seconds % 60).padStart(2, '0')}s`;
  };
  document.querySelectorAll('[data-dv-global-countdown]').forEach((node) => {
    const update = () => {
      const now = Date.now();
      const ends = Date.parse(node.dataset.endsAt);
      node.hidden = now < Date.parse(node.dataset.startsAt) || now >= ends;
      const clock = node.querySelector('time');
      if (clock && !node.hidden) clock.textContent = countdownText(ends - now);
    };
    update();
    window.setInterval(update, 1000);
  });

  const parseJSON = (node, fallback = []) => {
    if (!(node instanceof HTMLScriptElement)) return fallback;
    try {
      return JSON.parse(node.textContent || '');
    } catch (_error) {
      return fallback;
    }
  };

  document.querySelectorAll('[data-dv-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-dv-main]');
    if (!(main instanceof HTMLImageElement)) return;
    gallery.querySelectorAll('[data-dv-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        const src = button.getAttribute('data-src');
        const alt = button.getAttribute('data-alt') || '';
        const width = Number(button.getAttribute('data-width'));
        const height = Number(button.getAttribute('data-height'));
        const lifestyle = button.getAttribute('data-lifestyle') === 'true';
        if (!src) return;
        main.src = src;
        main.alt = alt;
        if (width > 0) main.width = width;
        if (height > 0) main.height = height;
        main.classList.toggle('dv-gallery__lifestyle', lifestyle);
        gallery.querySelectorAll('[data-dv-thumb]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
  });

  document.querySelectorAll('[data-dv-dual]').forEach((chooser) => {
    chooser.querySelectorAll('[data-dv-mode]').forEach((button) => {
      button.addEventListener('click', () => {
        const mode = button.getAttribute('data-dv-mode');
        chooser.querySelectorAll('[data-dv-mode]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        chooser.querySelectorAll('[data-dv-panel]').forEach((panel) => panel.setAttribute('data-active', String(panel.getAttribute('data-dv-panel') === mode)));
      });
    });
  });

  document.querySelectorAll('[data-dv-purchase-root]').forEach((purchaseRoot) => {
    const gallery = purchaseRoot.querySelector('[data-dv-product-gallery]');

    if (gallery) {
      const triggers = [...gallery.querySelectorAll('[data-dv-product-media-trigger]')];
      const panels = [...gallery.querySelectorAll('[data-dv-product-media-panel]')];
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const mediaId = trigger.getAttribute('data-media-id');
          triggers.forEach((item) => item.setAttribute('aria-pressed', String(item === trigger)));
          panels.forEach((panel) => {
            const active = panel.getAttribute('data-media-id') === mediaId;
            panel.hidden = !active;
            if (!active) panel.querySelectorAll('video').forEach((video) => video.pause());
          });
        });
      });
    }

    const form = purchaseRoot.querySelector('form.dv-pdp-form');
    const buyZone = purchaseRoot.querySelector('[data-dv-buy-zone]');
    const variantSelect = purchaseRoot.querySelector('[data-dv-variant-select]');
    const variantInput = purchaseRoot.querySelector('[data-dv-variant-input]');
    const variants = parseJSON(purchaseRoot.querySelector('[data-dv-variant-data]'));
    const price = purchaseRoot.querySelector('[data-dv-price]');
    const optionPrice = purchaseRoot.querySelector('[data-dv-option-price]');
    const stock = purchaseRoot.querySelector('[data-dv-low-stock]');
    const atc = purchaseRoot.querySelector('[data-dv-atc]');
    const atcLabel = purchaseRoot.querySelector('[data-dv-atc-label]');
    const quantity = purchaseRoot.querySelector('[data-dv-quantity]');
    const sticky = purchaseRoot.querySelector('[data-dv-sticky-atc]');
    const stickySubmit = purchaseRoot.querySelector('[data-dv-sticky-submit]');
    const stickyLabel = purchaseRoot.querySelector('[data-dv-sticky-label]');
    const stickyPrice = purchaseRoot.querySelector('[data-dv-sticky-price]');
    const bundle = purchaseRoot.querySelector('[data-dv-bundle-offer]');
    let selectedVariant = null;
    let adding = false;

    const updateBundle = () => {
      if (!bundle || !selectedVariant) return;
      const now = Date.now();
      const starts = Date.parse(bundle.dataset.startsAt);
      const ends = Date.parse(bundle.dataset.endsAt);
      const active = now >= starts && now < ends && String(selectedVariant.id) === bundle.dataset.campaignVariant;
      const currency = bundle.dataset.currency || 'USD';
      const exactUsd = active && currency === 'USD' && Number(selectedVariant.priceRaw) === 6999;
      const format = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'code' }).format(cents / 100);
      const template = (key, cents) => (bundle.dataset[key] || '__AMOUNT__').replace('__AMOUNT__', format(cents));
      const getTotal = (count) => Number(selectedVariant.priceRaw) * count - (exactUsd ? (count === 4 ? 5997 : count === 2 ? 1999 : 0) : 0);
      const countdown = bundle.querySelector('[data-dv-countdown]');
      if (countdown) countdown.hidden = !active;
      const clock = bundle.querySelector('[data-dv-countdown-clock]');
      if (clock && active) clock.textContent = countdownText(ends - now);
      const terms = bundle.querySelector('[data-dv-bundle-terms]');
      if (terms) terms.hidden = !active;
      const count = Number(quantity?.value) || 1;
      const max = Number.parseInt(quantity?.max, 10);
      bundle.querySelectorAll('[data-dv-bundle-card]').forEach((card) => {
        const cardCount = Number(card.dataset.count);
        const input = card.querySelector('input');
        input.checked = cardCount === count;
        input.disabled = adding || !selectedVariant.available || (Number.isFinite(max) && cardCount > max);
        if (input.checked) {
          purchaseRoot.querySelectorAll('[data-dv-selection-label], [data-dv-sticky-selection]').forEach((node) => { node.textContent = card.dataset.selection; });
          const contents = purchaseRoot.querySelector('[data-dv-package-contents]');
          if (contents) contents.textContent = card.dataset.contents;
        }
        const regular = Number(selectedVariant.priceRaw) * cardCount;
        const total = getTotal(cardCount);
        card.querySelector('[data-dv-bundle-total]').textContent = format(total);
        card.querySelector('[data-dv-bundle-each]').textContent = active && !exactUsd && cardCount > 1 ? bundle.dataset.checkoutLabel : template('eachLabel', Math.round(total / cardCount));
        const savings = card.querySelector('[data-dv-bundle-saving]');
        savings.hidden = regular === total;
        savings.textContent = template('saveLabel', regular - total);
        const separate = card.querySelector('[data-dv-bundle-regular]');
        separate.hidden = regular === total;
        separate.textContent = template('separateLabel', regular);
      });
      const total = getTotal(count);
      if (price) price.textContent = format(total);
      if (stickyPrice) stickyPrice.textContent = format(total);
      if (!adding && selectedVariant.available && Number(selectedVariant.priceRaw) > 0) {
        const label = active && !exactUsd && count > 1 ? bundle.dataset.addLabel : `${bundle.dataset.addLabel} · ${format(total)}`;
        if (atcLabel) atcLabel.textContent = label;
        if (stickyLabel) stickyLabel.textContent = bundle.dataset.addLabel;
      }
    };

    const setButtonState = (button, enabled) => {
      if (!(button instanceof HTMLButtonElement)) return;
      button.disabled = !enabled;
      button.setAttribute('aria-disabled', String(!enabled));
    };

    const updateVariant = (variantId) => {
      const variant = variants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;
      selectedVariant = variant;

      const hasPrice = Number(variant.priceRaw) > 0;
      const tracked = Boolean(variant.inventoryManagement);
      const inventory = Number(variant.inventoryQuantity) || 0;
      const denyOverselling = String(variant.inventoryPolicy).toLowerCase() === 'deny';
      const lowStock = tracked && inventory > 0 && inventory <= 8;
      const soldOut = !variant.available || (tracked && denyOverselling && inventory <= 0);
      const available = !soldOut && hasPrice;

      [price, optionPrice, stickyPrice].forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        node.hidden = !hasPrice;
        if (hasPrice) node.textContent = variant.price;
      });

      if (stock instanceof HTMLElement) {
        stock.hidden = !lowStock;
        stock.textContent = lowStock ? (stock.getAttribute('data-stock-template') || '') : '';
      }

      if (quantity instanceof HTMLInputElement) {
        if (tracked && denyOverselling && inventory > 0) {
          quantity.max = String(inventory);
          if ((Number.parseInt(quantity.value, 10) || 1) > inventory) quantity.value = String([1, 2, 4].filter((count) => count <= inventory).pop() || 1);
        } else {
          quantity.removeAttribute('max');
        }
      }

      const label = available ? `${purchaseRoot.dataset.addLabel} · ${variant.price}` : purchaseRoot.dataset[soldOut ? 'soldOutLabel' : 'unavailableLabel'];
      if (atcLabel) atcLabel.textContent = label;
      if (stickyLabel) stickyLabel.textContent = label;
      setButtonState(atc, available);
      setButtonState(stickySubmit, available);
      updateBundle();
    };

    if (variantSelect instanceof HTMLSelectElement) {
      updateVariant(variantSelect.value);
      variantSelect.addEventListener('change', () => updateVariant(variantSelect.value));
    } else if (variantInput instanceof HTMLInputElement) {
      updateVariant(variantInput.value);
    }
    bundle?.querySelectorAll('[data-dv-bundle-choice]').forEach((input) => {
      input.addEventListener('change', () => {
        if (quantity instanceof HTMLInputElement && input.checked) {
          quantity.value = input.value;
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
    if (bundle) {
      window.setInterval(updateBundle, 1000);
      window.addEventListener('pageshow', updateBundle);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) updateBundle(); });
    }

    purchaseRoot.querySelector('[data-dv-quantity-minus]')?.addEventListener('click', () => {
      if (!(quantity instanceof HTMLInputElement)) return;
      quantity.value = String(Math.max(1, (Number.parseInt(quantity.value, 10) || 1) - 1));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });

    purchaseRoot.querySelector('[data-dv-quantity-plus]')?.addEventListener('click', () => {
      if (!(quantity instanceof HTMLInputElement)) return;
      const current = Number.parseInt(quantity.value, 10) || 1;
      const max = Number.parseInt(quantity.max, 10);
      quantity.value = String(Number.isFinite(max) && max > 0 ? Math.min(max, current + 1) : current + 1);
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });

    quantity?.addEventListener('change', () => {
      if (!(quantity instanceof HTMLInputElement)) return;
      const max = Number.parseInt(quantity.max, 10);
      const next = Math.max(1, Number.parseInt(quantity.value, 10) || 1);
      quantity.value = String(Number.isFinite(max) && max > 0 ? Math.min(max, next) : next);
      updateBundle();
    });

    if (form instanceof HTMLFormElement) {
      form.addEventListener('submit', async (event) => {
        if (adding || (atc instanceof HTMLButtonElement && atc.disabled)) { event.preventDefault(); return; }
        if (event.defaultPrevented || !window.DouvaneCart) return;
        event.preventDefault();
        adding = true;
        setButtonState(atc, false);
        setButtonState(stickySubmit, false);
        if (atcLabel) atcLabel.textContent = purchaseRoot.dataset.addingLabel;
        if (stickyLabel) stickyLabel.textContent = purchaseRoot.dataset.addingLabel;
        updateBundle();
        try { await window.DouvaneCart.add(form); }
        finally {
          adding = false;
          updateVariant(variantSelect?.value || variantInput?.value);
        }
      });
    }

    stickySubmit?.addEventListener('click', () => {
      if (form instanceof HTMLFormElement && stickySubmit instanceof HTMLButtonElement && !stickySubmit.disabled) form.requestSubmit();
    });

    if (sticky instanceof HTMLElement && buyZone instanceof HTMLElement) {
      let frame = 0;
      const updateSticky = () => {
        frame = 0;
        const purchaseBounds = purchaseRoot.getBoundingClientRect();
        const atcBounds = atc instanceof HTMLElement ? atc.getBoundingClientRect() : null;
        const mainButtonVisible = atcBounds && atcBounds.top < window.innerHeight && atcBounds.bottom > 0;
        const hasReachedProduct = purchaseBounds.top < 0 && purchaseBounds.bottom > 0;
        const shouldShow = window.matchMedia('(max-width: 720px)').matches && hasReachedProduct && !mainButtonVisible;
        sticky.hidden = !shouldShow;
        document.body.classList.toggle('dv-has-sticky-atc', shouldShow);
      };
      const requestStickyUpdate = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(updateSticky);
      };
      updateSticky();
      window.addEventListener('scroll', requestStickyUpdate, { passive: true });
      window.addEventListener('resize', requestStickyUpdate);
    }
  });

  document.querySelectorAll('[data-dv-newsletter-popup]').forEach((popup) => {
    const dialog = popup.querySelector('[data-dv-newsletter-dialog]');
    if (!(dialog instanceof HTMLDialogElement) || window.Shopify?.designMode) return;

    const storageKey = popup.getAttribute('data-storage-key') || 'douvane-newsletter-dismissed-at';
    const sessionKey = popup.getAttribute('data-session-key') || 'douvane-newsletter-shown';
    const mobile = window.matchMedia('(max-width: 720px)').matches;
    const delay = Number(popup.getAttribute(mobile ? 'data-mobile-delay' : 'data-desktop-delay')) || (mobile ? 25000 : 15000);
    const threshold = Number(popup.getAttribute(mobile ? 'data-mobile-scroll-threshold' : 'data-desktop-scroll-threshold')) || (mobile ? 0.35 : 0.25);
    const dismissMs = (Number(popup.getAttribute('data-dismiss-days')) || 7) * 24 * 60 * 60 * 1000;
    const signupMs = (Number(popup.getAttribute('data-signup-days')) || 180) * 24 * 60 * 60 * 1000;
    const success = popup.querySelector('[data-dv-newsletter-success]');
    const errors = popup.querySelector('[data-dv-newsletter-errors]');
    const scratch = popup.querySelector('[data-dv-scratch]');
    const scratchCanvas = popup.querySelector('[data-dv-scratch-canvas]');
    const scratchPrompt = popup.querySelector('[data-dv-scratch-prompt]');
    const scratchReveal = popup.querySelector('[data-dv-scratch-reveal]');
    const newsletterGate = popup.querySelector('[data-dv-newsletter-gate]');
    const emailInput = popup.querySelector('input[type="email"]');
    const commerceIntentKey = 'douvane-commerce-intent';
    let opened = false;
    let timer = 0;
    let timeReady = false;
    let scrollReady = false;
    let returnFocus = null;

    const readSessionValue = (key) => {
      try {
        return window.sessionStorage.getItem(key);
      } catch (_error) {
        return null;
      }
    };

    const writeSessionValue = (key, value) => {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (_error) {
        // Session storage can be unavailable in strict privacy modes.
      }
    };

    const readSuppressedUntil = () => {
      try {
        return Number(window.localStorage.getItem(storageKey)) || 0;
      } catch (_error) {
        return 0;
      }
    };

    const suppressFor = (duration) => {
      try {
        window.localStorage.setItem(storageKey, String(Math.max(readSuppressedUntil(), Date.now() + duration)));
      } catch (_error) {
        // Storage can be unavailable in strict privacy modes; the dialog still remains dismissible.
      }
    };

    const shownThisSession = () => readSessionValue(sessionKey) === 'true';
    const markShownThisSession = () => writeSessionValue(sessionKey, 'true');

    const isCommerceBusy = () => {
      const commerceRoute = /^\/(cart|checkouts?)(\/|$)/.test(window.location.pathname);
      const anotherModal = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some((node) => {
        if (node === dialog || dialog.contains(node) || node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
        if (node instanceof HTMLDialogElement) return node.open;
        const style = window.getComputedStyle(node);
        return style.display !== 'none' && style.visibility !== 'hidden' && node.getClientRects().length > 0;
      });
      const activeDrawer = Boolean(document.querySelector('cart-drawer[open], .cart-drawer.active, .drawer.is-open, [data-cart-drawer][open], [data-menu-drawer][open]'));
      return commerceRoute || anotherModal || activeDrawer || readSessionValue(commerceIntentKey) === 'true';
    };

    const revealScratch = (focusEmail = false) => {
      if (scratch instanceof HTMLElement) scratch.setAttribute('data-revealed', 'true');
      if (scratchCanvas instanceof HTMLCanvasElement) scratchCanvas.hidden = true;
      if (scratchPrompt instanceof HTMLElement) scratchPrompt.hidden = true;
      if (scratchReveal instanceof HTMLButtonElement) scratchReveal.hidden = true;
      if (newsletterGate instanceof HTMLElement) newsletterGate.hidden = false;
      if (focusEmail && emailInput instanceof HTMLElement) window.requestAnimationFrame(() => emailInput.focus());
    };

    let scratchInitialized = false;
    const initializeScratch = () => {
      if (scratchInitialized) return;
      scratchInitialized = true;
      if (!(scratchCanvas instanceof HTMLCanvasElement) || errors) {
        if (errors) revealScratch(false);
        return;
      }
      const context = scratchCanvas.getContext('2d', { willReadFrequently: true });
      if (!context) {
        revealScratch(false);
        return;
      }

      const width = scratchCanvas.width;
      const height = scratchCanvas.height;
      let drawing = false;
      let lastPoint = null;

      const enableErasing = () => {
        context.globalCompositeOperation = 'destination-out';
        context.lineCap = 'round';
        context.lineJoin = 'round';
        context.lineWidth = 58;
      };

      context.fillStyle = '#0b2f54';
      context.fillRect(0, 0, width, height);
      const texture = new Image();
      texture.crossOrigin = 'anonymous';
      texture.onload = () => {
        context.globalCompositeOperation = 'source-over';
        const scale = Math.max(width / texture.naturalWidth, height / texture.naturalHeight);
        const drawWidth = texture.naturalWidth * scale;
        const drawHeight = texture.naturalHeight * scale;
        context.drawImage(texture, (width - drawWidth) / 2, (height - drawHeight) / 2, drawWidth, drawHeight);
        enableErasing();
      };
      texture.onerror = enableErasing;
      texture.src = scratchCanvas.getAttribute('data-texture') || '';

      const pointFromEvent = (event) => {
        const rect = scratchCanvas.getBoundingClientRect();
        return {
          x: (event.clientX - rect.left) * (width / rect.width),
          y: (event.clientY - rect.top) * (height / rect.height),
        };
      };

      const eraseTo = (point) => {
        context.beginPath();
        if (lastPoint) context.moveTo(lastPoint.x, lastPoint.y);
        else context.moveTo(point.x, point.y);
        context.lineTo(point.x, point.y);
        context.stroke();
        lastPoint = point;
      };

      const scratchedEnough = () => {
        try {
          const pixels = context.getImageData(0, 0, width, height).data;
          let transparent = 0;
          let sampled = 0;
          for (let index = 3; index < pixels.length; index += 4 * 24) {
            sampled += 1;
            if (pixels[index] < 24) transparent += 1;
          }
          return sampled > 0 && transparent / sampled >= 0.38;
        } catch (_error) {
          return true;
        }
      };

      scratchCanvas.addEventListener('pointerdown', (event) => {
        drawing = true;
        lastPoint = pointFromEvent(event);
        scratchCanvas.setPointerCapture?.(event.pointerId);
        eraseTo(lastPoint);
      });
      scratchCanvas.addEventListener('pointermove', (event) => {
        if (!drawing) return;
        eraseTo(pointFromEvent(event));
      });
      const stopDrawing = () => {
        if (!drawing) return;
        drawing = false;
        lastPoint = null;
        if (scratchedEnough()) revealScratch(true);
      };
      scratchCanvas.addEventListener('pointerup', stopDrawing);
      scratchCanvas.addEventListener('pointercancel', stopDrawing);
      scratchCanvas.addEventListener('pointerleave', stopDrawing);
      scratchReveal?.addEventListener('click', () => revealScratch(true));
    };

    const stopTriggers = () => {
      if (timer) window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
    };

    const show = (force = false) => {
      if (opened || dialog.open) return;
      if (!force && (shownThisSession() || Date.now() < readSuppressedUntil())) return;
      if (!force && isCommerceBusy()) return;
      opened = true;
      stopTriggers();
      returnFocus = document.activeElement;
      markShownThisSession();
      if (!success) initializeScratch();
      dialog.showModal();
      const focusTarget = success || errors || scratchReveal || dialog.querySelector('input[type="email"]') || dialog.querySelector('[data-dv-newsletter-close]');
      if (focusTarget instanceof HTMLElement) window.requestAnimationFrame(() => focusTarget.focus());
    };

    const maybeShow = () => {
      if (timeReady && scrollReady && !isCommerceBusy()) show();
    };

    const onScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      scrollReady = scrollable > 0 && window.scrollY / scrollable >= threshold;
      maybeShow();
    };

    popup.querySelectorAll('[data-dv-newsletter-close]').forEach((button) => {
      button.addEventListener('click', () => dialog.close('dismissed'));
    });
    popup.querySelector('[data-dv-newsletter-copy]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const status = popup.querySelector('[data-dv-newsletter-copy-status]');
      if (!(button instanceof HTMLButtonElement)) return;
      const code = button.getAttribute('data-code') || '';
      if (!code) return;
      try {
        await window.navigator.clipboard.writeText(code);
        button.textContent = popup.dataset.copyLabel;
        if (status instanceof HTMLElement) status.textContent = popup.dataset.copySuccess;
      } catch (_error) {
        if (status instanceof HTMLElement) status.textContent = popup.dataset.copyFallback.replace('__CODE__', code);
      }
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close('dismissed');
    });
    dialog.addEventListener('close', () => {
      opened = false;
      suppressFor(success ? signupMs : dismissMs);
      if (returnFocus instanceof HTMLElement && returnFocus.isConnected) window.requestAnimationFrame(() => returnFocus.focus());
    });

    document.querySelectorAll('[data-dv-newsletter-open]').forEach((button) => {
      button.addEventListener('click', () => show(true));
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && form.action.includes('/cart/add')) writeSessionValue(commerceIntentKey, 'true');
    }, true);

    if (success) {
      suppressFor(signupMs);
      show(true);
      return;
    }

    if (errors) {
      show(true);
      return;
    }

    if (shownThisSession() || Date.now() < readSuppressedUntil()) return;
    timer = window.setTimeout(() => {
      timeReady = true;
      maybeShow();
    }, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });

  root.classList.add('douvane-redesign-ready');
})();
